import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { DataTables } from 'pages/Home/ModalReport/component/Table';
import { TableHeaderLabel } from 'pages/Home/ModalReport/component/Table/TableHead';

const styles = StyleSheet.create({
  table: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    borderBottomStyle: 'solid',
  },
  tableHeader: {
    backgroundColor: '#ffff',
    fontWeight: 'bold',
    textAlign: 'right',
  },
  tableCell: {
    padding: 5,
  },
  tableCellLeft: {
    textAlign: "left"
  },
  tableCellRight: {
    textAlign: "right"
  },
  tableCellCenter: {
    textAlign: "center"
  },
  tableCellLast: {
    padding: 5,
    textAlign: 'right',
  },
});

interface TableProps {
  tableHeaders: TableHeaderLabel[],
  dataTables: DataTables[],
  columnWidths: number[]
}

const Table: React.FC<TableProps> = ({ tableHeaders,dataTables, columnWidths }) => {
  const totalColumns = tableHeaders.length
  
  return (
    <View style={styles.table}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        {tableHeaders?.map((header, index) => {
          const isLastCellInRow = index === tableHeaders.length - 1;
          return <Text style={
            [
              isLastCellInRow && styles.tableCellLast, 
              styles.tableCell,
              {width: columnWidths[index]}
            ]}>{header.label}</Text>;
        })}
      </View>
      {dataTables?.map((row, rowIndex) => {
        let currentColumnIndex = 0;
        return (
          <View key={rowIndex} style={styles.tableRow}>
            {row.data2?.map((cell, cellIndex) => {
              const colspan = cell.colspan || 1;
              let cellWidth = 0;
              for (let i = 0; i < colspan; i++) {
                cellWidth += columnWidths[currentColumnIndex + i] || 0;
              }

              const isLastCellInRow = cellIndex === tableHeaders.length - 1;

              currentColumnIndex += colspan;

              if (currentColumnIndex > totalColumns) {
                return null;
              }

              return (
                <Text
                  key={cellIndex}
                  style={[
                    isLastCellInRow && styles.tableCellLast,
                    styles.tableCell,
                    { width: cellWidth },
                    cellIndex === 0 && styles.tableCellLeft,
                    cellIndex === 1 && styles.tableCellCenter,
                    cellIndex > 1 && styles.tableCellRight,

                  ]}
                >
                  {cell.content}
                </Text>
              );
            })}
          </View>
        );
      })}
    </View>
  );
};

export default Table;
